<section class="geo-kachel-wrapper" #schritte aria-live="polite" [attr.aria-label]="ariaLabel"
     [style.pointer-events]="lock ? 'none' : 'all'"
     [id]="_id+'_Wrapper'">
  <div [@slide]="state[0]" (@slide.done)="animationDone($event)" (@slide.start)="animationStart($event)"
       class="slidable" [ngClass]="state[0]"
       [attr.aria-hidden]="aktuellerSchritt !== 1" [id]="_id+'_1'">
    <ng-content select="[schritt='1']"></ng-content>
  </div>
  <div [@slide]="state[1]" (@slide.done)="animationDone($event)" (@slide.start)="animationStart($event)"
       class="slidable" [ngClass]="state[1]"
       [attr.aria-hidden]="aktuellerSchritt !== 2" [id]="_id+'_2'">
    <ng-content select="[schritt='2']"></ng-content>
  </div>
  <div [@slide]="state[2]" (@slide.done)="animationDone($event)" (@slide.start)="animationStart($event)"
       class="slidable" [ngClass]="state[2]"
       [attr.aria-hidden]="aktuellerSchritt !== 3" [id]="_id+'_3'">
    <ng-content select="[schritt='3']"></ng-content>
  </div>
  <div [@slide]="state[3]" (@slide.done)="animationDone($event)" (@slide.start)="animationStart($event)"
       class="slidable" [ngClass]="state[3]"
       [attr.aria-hidden]="aktuellerSchritt !== 4" [id]="_id+'_4'">
    <ng-content select="[schritt='4']"></ng-content>
  </div>
  <div [@slide]="state[4]" (@slide.done)="animationDone($event)" (@slide.start)="animationStart($event)"
       class="slidable" [ngClass]="state[4]"
       [attr.aria-hidden]="aktuellerSchritt !== 5" [id]="_id+'_5'">
    <ng-content select="[schritt='5']"></ng-content>
  </div>
  <div [@slide]="state[5]" (@slide.done)="animationDone($event)" (@slide.start)="animationStart($event)"
       class="slidable" [ngClass]="state[5]"
       [attr.aria-hidden]="aktuellerSchritt !== 6" [id]="_id+'_6'">
    <ng-content select="[schritt='6']"></ng-content>
  </div>
  <div [@slide]="state[6]" (@slide.done)="animationDone($event)" (@slide.start)="animationStart($event)"
       class="slidable" [ngClass]="state[6]"
       [attr.aria-hidden]="aktuellerSchritt !== 7" [id]="_id+'_7'">
    <ng-content select="[schritt='7']"></ng-content>
  </div>
</section>
